(function() {

	$('.placeholder--video').each(function() {

		var
			$link  = $(this),
			$img   = $link.find('.placeholder__img').first();

		$link.on('click', function(e) {

			e.preventDefault();

			if ($link.hasClass(bem.states.active)) {
				return;
			}

			$link
				.addClass(bem.states.active)
				.removeAttr('href');

			$img
				.before($('<iframe />').attr({
					allowfullscreen: 'allowfullscreen',
					class: 'placeholder__img',
					allowfullscreen: true,
					frameborder: 0,
					src: 'https://www.youtube.com/embed/' + $link.data('youtube-id') + '?autoplay=1&amp;showinfo=0&amp;controls=1&amp;rel=0'
				}))
				.remove();

		});

	});

}());
